import { Button, DialogActions, DialogContent, DialogTitle, Modal, ModalDialog, Typography } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";

interface WorkOrderHistoryRecord {
	event_date: string;
	user_name: string;
	event_description: string;
	event_type: string;
}

interface WorkOrderHistoryDialogProps {
	open: boolean;
	packingListId: string;
	invoiceNumber: string;
	onClose: () => void;
}

export default function WorkOrderHistoryDialog(props: WorkOrderHistoryDialogProps) {
	const [history, setHistory] = React.useState<Array<WorkOrderHistoryRecord>>([]);
	const [isLoading, setIsLoading] = React.useState(false);

	React.useEffect(() => {
		if (props.open && props.packingListId) {
			setIsLoading(true);
			fetch("PackingList/GetPackingListWorkOrderHistory", {
				method: "POST",
				cache: "no-cache",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ packingListId: props.packingListId }),
			})
				.then((x) => x.json())
				.then((x) => {
					setHistory(x);
					setIsLoading(false);
				});
		}
	}, [props.open, props.packingListId]);

	return (
		<Modal open={props.open}>
			<ModalDialog sx={{ width: 700, maxHeight: "80vh", overflow: "auto" }}>
				<DialogTitle>View History - {props.invoiceNumber}</DialogTitle>
				<DialogContent>
					{isLoading ? (
						<Typography>Loading...</Typography>
					) : history.length === 0 ? (
						<Typography level="body-sm">No history found.</Typography>
					) : (
						history.map((record, idx) => (
							<Typography key={idx} level="body-sm" sx={{ mb: 1 }}>
								{Util.Formatter(record.event_date, "DT")} – {record.user_name} – {record.event_description}
							</Typography>
						))
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={props.onClose} color="primary">
						Close
					</Button>
				</DialogActions>
			</ModalDialog>
		</Modal>
	);
}
